module.exports = __webpack_public_path__ + "img/menu1.bda860bb.png";